/* Keeps a promo gift tied to the plan that earned it.
 *
 * The gift is zeroed by a Shopify automatic discount that requires its plan in
 * the cart. Left behind on its own the discount stops applying and the customer
 * is charged for it, so the orphan is removed here. Browser-side only — it
 * cannot cover a cart edited outside the storefront.
 */
(function () {
  // One property per promo; each names the handle of the product that earns it.
  var GIFT_PROPS = ["_mtf_gift", "_advent_gift", "_advent_bundle"];
  // A bundle add-on is paid for, not zeroed by a discount, so the cart is only
  // ever trimmed for it — never topped up. Raising the calendar quantity in the
  // drawer must not quietly charge for a second kit nobody asked for.
  var PAID_PROPS = ["_advent_bundle"];
  var busy = false;

  function giftPropName(item) {
    var props = item && item.properties;
    if (!props) return null;
    for (var i = 0; i < GIFT_PROPS.length; i++) {
      if (props[GIFT_PROPS[i]]) return GIFT_PROPS[i];
    }
    return null;
  }

  function giftProp(item) {
    var name = giftPropName(item);
    return name ? item.properties[name] : null;
  }

  function isPaid(item) {
    return PAID_PROPS.indexOf(giftPropName(item)) !== -1;
  }

  function change(key, quantity) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) {
      if (!r.ok) throw new Error("cart change failed (" + r.status + ")");
      return r.json();
    });
  }

  function refresh() {
    document.dispatchEvent(new CustomEvent("dispatch:cart-drawer:refresh"));
    document.documentElement.dispatchEvent(
      new CustomEvent("theme:cartchanged", { bubbles: true, cancelable: false })
    );
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent("cart:build", { bubbles: true, detail: cart }));
      })
      .catch(function () {});
  }

  function audit() {
    if (busy) return;
    busy = true;
    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var gifts = items.filter(giftProp);
        if (!gifts.length) return null;

        // Shopify splits a line when a discount covers only some of its units, so
        // one gift can arrive as several lines — reconcile the group, not each line.
        var groups = {};
        gifts.forEach(function (gift) {
          var earner = (gift.properties && gift.properties._advent_gift_for) || '';
          var k = giftProp(gift) + '|' + earner;
          (groups[k] = groups[k] || []).push(gift);
        });

        var work = [];
        Object.keys(groups).forEach(function (k) {
          var lines = groups[k];
          var parent = giftProp(lines[0]);
          var earner = lines[0].properties && lines[0].properties._advent_gift_for;
          var paid = isPaid(lines[0]);
          var isGift = {};
          lines.forEach(function (l) { isGift[l.key] = true; });

          var earned = items.reduce(function (n, item) {
            if (isGift[item.key]) return n;
            if (earner) {
              return String(item.variant_id || item.id) === String(earner) ? n + item.quantity : n;
            }
            if (item.handle !== parent) return n;
            return paid ? n + item.quantity : Math.max(n, 1);
          }, 0);

          // Match the gift count to what the cart earns, in both directions, so raising
          // the quantity in the drawer cannot leave someone short. Topping up only ever
          // raises a line that is already there — a gift the shopper deleted stays gone,
          // because there is no line to raise and we never add one back.
          var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
          if (have === earned) return;

          if (have < earned) {
            if (paid) return;
            work.push({ key: lines[0].key, quantity: lines[0].quantity + (earned - have) });
            return;
          }

          var left = earned;
          lines.forEach(function (line) {
            var want = Math.min(line.quantity, left);
            left -= want;
            if (want !== line.quantity) work.push({ key: line.key, quantity: want });
          });
        });

        if (!work.length) return null;
        // sequential: each change re-keys the remaining lines
        return work.reduce(function (chain, job) {
          return chain.then(function () { return change(job.key, job.quantity); });
        }, Promise.resolve());
      })
      .then(function (changed) { if (changed) refresh(); })
      .catch(function () {})
      .then(function () { busy = false; });
  }

  ["cart:build", "cart:refresh", "theme:cartchanged"].forEach(function (evt) {
    document.addEventListener(evt, function () { window.setTimeout(audit, 60); });
  });

  // "Add another starter kit": one more bundle kit, grouped with the others by handle
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-kit-offer]");
    if (!btn) return;
    e.preventDefault();
    if (btn.hasAttribute("aria-disabled")) return;
    btn.setAttribute("aria-disabled", "true");
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        items: [{
          id: parseInt(btn.dataset.kitVariant, 10),
          quantity: 1,
          properties: { _advent_bundle: btn.dataset.kitHandle }
        }]
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error("kit add failed (" + r.status + ")");
        refresh();
      })
      .catch(function () { btn.removeAttribute("aria-disabled"); });
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", audit);
  } else {
    audit();
  }
})();
